module.exports = __webpack_public_path__ + "static/media/exam_8_demo.c2adbad1.xlsx";